export const DEFAULT_VIDEO_MAX_WIDTH = 1224;
export const VIDEO_CONTROLS_COLOR = 'FAC1BD'; // theme color Morning
